module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./FulaifuRoadView.js"));
	}, "FulaifuRoadView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FulaifuRoadView!./src/pages/Shop/Home/MemberBirthday/FulaifuRoad/FulaifuRoadView.js
// module id = 919
// module chunks = 438